// extracted by mini-css-extract-plugin
export var paging = "paging__JjvO";
export var select = "select__Kv_7";
export var selectBlock = "select-block__mzbL";